import React, { useState } from "react";

import CustomDropdown from "../CustomDropdown/CustomDropdown";
import styles from "./SubMapping.module.css";

const COLUMN_OPTIONS = ["Column 1", "Column 2", "Column 3"];

const CURRENCY_FIELDS = [
  { id: "usd", label: "USD", required: false, type: "dropdown" },
  {
    id: "closingRateUSD",
    label: "Closing Rate",
    required: false,
    type: "input",
    placeholder: "Enter Values",
  },
  { id: "eur", label: "EUR", required: false, type: "dropdown" },
  {
    id: "closingRateEUR",
    label: "Closing Rate",
    required: false,
    type: "input",
    placeholder: "Enter Values",
  },
  { id: "inr", label: "INR", required: false, type: "dropdown" },
  {
    id: "closingRateINR",
    label: "Closing Rate",
    required: false,
    type: "input",
    placeholder: "Enter Values",
  },
];

export default function Currency() {
  const [selectedValues, setSelectedValues] = useState(
    CURRENCY_FIELDS.reduce((acc, field) => ({ ...acc, [field.id]: "" }), {})
  );

  const handleFieldChange = (fieldId, value) => {
    setSelectedValues((prev) => ({ ...prev, [fieldId]: value }));
  };

  return (
    <div className={styles.formGroupGrid}>
      {CURRENCY_FIELDS.map((field) =>
        field.type === "dropdown" ? (
          <CustomDropdown
            key={field.id}
            label={field.label}
            value={selectedValues[field.id]}
            onChange={(value) => handleFieldChange(field.id, value)}
            options={COLUMN_OPTIONS}
            placeholder="Map Column"
            required={field.required}
          />
        ) : (
          <div key={field.id} className={styles.inputField}>
            <label className={styles.inputLabel}>
              {field.required && <span className={styles.required}>* </span>}
              {field.label}
            </label>
            <input
              type="text"
              className={styles.textInput}
              placeholder={field.placeholder}
              value={selectedValues[field.id]}
              onChange={(e) => handleFieldChange(field.id, e.target.value)}
            />
          </div>
        )
      )}
    </div>
  );
}
